import type { FaireProductEntity } from "../../entity_types/product";

export const p_558pzv49x7: FaireProductEntity = {
  token: "p_558pzv49x7",
  type: "product",
  name: "OVERSIZED SHELL TRIM CROCHET PONCHO",
  brandToken: "b_22tswwgnqb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1f6e933f7e755e6e4d3b3de36e22a376cb6385e848d97c7f66988bc06bef7217.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b60cdd27a7726b495534daa1a518096b4a99e908fda83b87a40ff46a65de6dd.jpeg",
    "https://cdn.faire.com/fastly/a84a06a911c8773976de1d0db96278852a9da08dbe3ff693ff7aea6a11a323e9.jpeg",
    "https://cdn.faire.com/fastly/adc7993d9f086698588932ea5e9d12da1d1390cad7ced4dea29e1180bc622d36.jpeg",
    "https://cdn.faire.com/fastly/377cc613478379e8c78507472e6b6d4aaabaa882829f964a7f6b290dafdb436b.jpeg",
    "https://cdn.faire.com/fastly/cfa7836d98f3307f0e6ec0fd6381a68a3e8978e52178d77bdff8f7c0bc03f898.jpeg",
    "https://cdn.faire.com/fastly/3d01392564d342ffb8c5d3aab2e7d09f4b1eab8908748b8034bb66de14ff0709.jpeg",
    "https://cdn.faire.com/fastly/472fe26fd32dfacc106b3da46e24e742dba3faee4bf6fc11fef5ba1ad1b943e2.jpeg",
    "https://cdn.faire.com/fastly/afaee9b87960c8fe21402660159a9fe0e7eeab7459f2a870b4d9cf26360d4f50.jpeg",
    "https://cdn.faire.com/fastly/6c19eb2c7161916d2e10a08c7cacecf5b6dc26a8c4481cc1f7bf0b9e244929d5.jpeg",
    "https://cdn.faire.com/fastly/59ce7563410b67e4b8d5af97fff73c4c6cac820e8b208932282be2a947640e96.jpeg",
    "https://cdn.faire.com/fastly/9ede7a90cabfe42dc12f1bef14a9038f0dfe8f19e84abbd21b54cc984282e77c.jpeg",
    "https://cdn.faire.com/fastly/5fe1d079f18c00262a8cf685a0ad0a175701b94084640826896dec922a5a1e6b.jpeg",
    "https://cdn.faire.com/fastly/a23bc8fb4fd0da9e695c95771cc687dba1945bb5a4c093f558318aa0da2c85f2.jpeg",
    "https://cdn.faire.com/fastly/f5c77f37e33e7b20a757fe81fe35691da3094cf2912ba1b95bd9e92b5a4fa64e.jpeg",
    "https://cdn.faire.com/fastly/13113a7a3677be58eae22e2fd88d30bc1ddb0cb9ae913a451e4e4ab9ab3160af.jpeg",
    "https://cdn.faire.com/fastly/9d0a19ce1db5fdaa546d85e6b163312f173265eebb5813cefd4f597d340ed0b1.jpeg",
    "https://cdn.faire.com/fastly/68d5b82e02949246c433aa4c3f7536ed6be15beab0a3b43274c3426cbd1de23e.jpeg",
    "https://cdn.faire.com/fastly/de414c0c6b33639b82efb1f182ae4fff7bcbf7585d959b33c2927fc05c681407.jpeg",
    "https://cdn.faire.com/fastly/8e3a52349120724d0b1adeb0fce4e4ec63be56469e6e81a1c255389562ba2e54.jpeg",
    "https://cdn.faire.com/fastly/8d32809f16897acf47d55f4d43212e970c574e53c5f4fc40e7b09e0c5a1f359c.jpeg",
    "https://cdn.faire.com/fastly/78a53f727a92586cfadf9c1a3654e964bf73285e7fa861917602665da284451e.jpeg",
    "https://cdn.faire.com/fastly/c9749d29ed7a30de4f0aa0ec2e75bda04b6475f192cf2c5a25831ead3fff4dca.jpeg",
    "https://cdn.faire.com/fastly/d4f84c7d2dc92ce450e6ab6549ca0bd24b3bef92e603fd3a96c1dd4fea5d3f89.jpeg",
    "https://cdn.faire.com/fastly/644a02a55196fe91e7bf1441df041905e4ff86cb5001fb2573578ff170cee2db.jpeg",
  ],
  priceDollars: 220.33,
  description: "SIZE & FIT :\n\nMODEL WEARS SIZE SMALL\nMODEL'S HEIGHT 5'9",
  tags: [],
  msrpDollars: 440.65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:29.026Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
